module.exports = __webpack_public_path__ + "static/media/app.261c3548.svg";